import { Component, OnInit } from '@angular/core';
import { QuestItemService } from './quest-item.service';
import { LoginService } from '../login.service';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'qst-quest',
  templateUrl: './quest.component.html',
  styleUrls: ['./quest.component.scss']
})
export class QuestComponent implements OnInit {
  questItems: string;

  questSections: number[];

  name: string = "brian";
  subscription: Subscription;

  constructor(  private loginService: LoginService, 
                private questItemService: QuestItemService,
                private router: Router ) {
    
    console.log("Quest.constructor()");
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.router.navigated) {
          console.log("Browser Refresh");
          this.router.navigate(['/loading']);
        }
      }
    });
  }

  ngOnInit(): void {
    //this.questItemService.initialize();

    this.questSections = this.questItemService.getSectionIds();

  }

  updateCurrentScore(score: string) {
    var scoreElement: HTMLElement;

    console.log("QuestComponent.updateCurrentScore: " + score);

    scoreElement = document.getElementById("currentScore");
    scoreElement.innerHTML = this.questItemService.getScoreString();
  }

}
